import {Component,Inject} from 'ng-metadata/core';

import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {JournalsService} from "../../../journals/journals.service";
import {getVid} from "../../../appConfig/appConfigForward";
import {DatabasesService} from "../../../journals/databases.service";
import {NewspapersService} from '../../../newspapers/newspapers.service';
import {SearchService} from '../../search.service';
import {MediaQueries} from "../../../infra/mediaQueries.service";
import {ChangeLangService} from '../../../infra/lang/changeLang.service';
//your imports go here


@Component({
selector: 'prm-back-to-search-results-button',
templateUrl: 'components/search/fullView/backToSearchResultsButton/back-to-search-results-button.html',
})



export class PrmBackToSearchResultsButton{
    private backToBrowseLabel: string;

    constructor(@Inject('$stateParams')  private $stateParams:ng.ui.IStateParamsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private searchService: SearchService,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private newspapersService : NewspapersService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private changeLangService: ChangeLangService,
                private mediaQueries: MediaQueries) {
        if (this.$stateParams['mode'] === 'browse'){
            this.initBackToBrowseLabel();
        }
    }

    private navigateBackToSearchResults(){
        let params={    vid: this.$stateParams['vid'],
                        query: this.$stateParams['query'],
                        search_scope: this.$stateParams['search_scope'],
                        tab: this.$stateParams['tab'],
                        sortby: this.$stateParams['sortby'],
                        facet: this.$stateParams['facet'],
                        mode: this.$stateParams['mode'],
                        pfilter: this.$stateParams['pfilter'],
                        offset: this.$stateParams['offset'],
                        journals: this.$stateParams['journals'],
                        databases: this.$stateParams['databases'],
                        pcAvailability: this.$stateParams['pcAvailability'],
                        searchInFulltext: this.$stateParams['searchInFulltext'],
                        searchCDI: this.$stateParams['searchCDI']
                    };
        let state = STATE_NAMES.SEARCH;

        if(this.$stateParams["fromFeaturedResult"]){
            params.tab = this.$stateParams['originTab'];
            params.search_scope = this.$stateParams['originScope'];
            this.$stateParams['originTab'] = undefined;
            this.$stateParams['originTab'] = undefined;
            this.$stateParams["fromFeaturedResult"] = undefined;

        }

        if(this.journalsService.isJournalSearch()){
            state = STATE_NAMES.JOURNAL_SEARCH;
        }
        if(this.databasesService.isDBSearch()){
            state = STATE_NAMES.DB_SEARCH;
        }
        if(this.newspapersService.isNewspapersSearch()){
            state = STATE_NAMES.NEWSPAPERS;
        }
        console.log ('Back URL from full view: Remove title, decription and schema.org of closed item.');
        this.searchService.removeSEOData();
        
        this.$state.go(state, params, {reload: false});
    }

    private isBackToSearchRequired(){
        if(this.$stateParams['query'] || this.$stateParams['mode'] === 'browse'){
            return true;
        }
        return false;
    }

    public initBackToBrowseLabel(){
        let scopeToLabelCode= {
            subject: 'subjects',
            author:'authors',
            title: 'titles',
            series: 'series'
        }
        if(this.$stateParams['browseScope'].includes('callnumber')){
            this.$translate('browse.back.to.callnumbers').then((label)=>{
                this.backToBrowseLabel= label;
            });
        }
        // This is for Primo VE. There are multiple subject browse options.
        else if(this.$stateParams['browseScope'].includes('subject')){
            this.$translate('browse.back.to.subjects').then((label)=>{
                this.backToBrowseLabel= label;
            });
        }
        else{
            this.$translate('browse.back.to.' + scopeToLabelCode[this.$stateParams['browseScope']]).then((label)=>{
                this.backToBrowseLabel= label;
            });
        }
    }

    get isBrowseMode(){
        return this.$stateParams['mode'] === 'browse';
    }

    get browseScope(){
        return this.$stateParams['browseScope'];
    }

    get browseState(){
        return STATE_NAMES.BROWSE_SEARCH;
    }

    get backToBrowseParams(){
        return {
            vid: getVid(),
            browseQuery: this.$stateParams['browseQuery'],
            browseScope: this.$stateParams['browseScope'],
            browseFirstTerm: this.$stateParams['browseFirstTerm'],
            innerPnxIndex: this.$stateParams['innerPnxIndex'],
            numOfUsedTerms: this.$stateParams['numOfUsedTerms'],
            fn: this.$stateParams['fn'],

        }
    }

    private isRTL () {
        return this.changeLangService.direction === 'rtl';
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/backToSearchResultsButton/backToSearchResultsButton.directive.ts